<template>
  <div class="input-com">
    <div class="input-warp">
      <div class="label-title">{{ label }}：</div>

      <el-input
        clearable
        :maxlength="6"
        :placeholder="placeholder"
        class="el-input"
        :value="value"
        @change="change"
        @mousewheel.native.prevent
        @input="inputValueChange"
      ></el-input>
      <i slot="suffix" class="suffix-words">{{ suffix }}</i>
    </div>
  </div>
</template>
<script>
export default {
  name: 'InputCom',
  components: {},
  props: {
    label: {
      default: '召开前',
      type: String,
    },
    suffix: {
      default: '',
      type: String,
    },
    placeholder: {
      default: '',
      type: String,
    },
    value: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      inputValue: '',
    };
  },
  watch: {},
  mounted() {},
  created() {},
  methods: {
    /**
     *
     */
    inputValueChange(e) {
      this.$emit('input', e);
    },
    change(e) {
      this.$emit('change', e);
    },
  },
};
</script>
<style lang="scss" scoped>
.input-com {
  .input-warp {
    display: flex;
    align-items: center;
    .label-title {
      white-space: nowrap;
    }
    .suffix-words {
      margin-left: 10px;
    }
  }
  ::v-deep {
    .el-input__inner {
      width: 164px;
    }
    .el-input__clear {
      transform: translateY(-14px);
    }
    .el-input__suffix {
      top: 16px;
      right: 16px;
      font-size: 16px;
      letter-spacing: 0;
      color: #303133;
      transition: all 0.3s;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
    }
    input[type='number'] {
      -moz-appearance: textfield !important;
    }
  }
}
</style>
